export const SOURCE_STATUS_LABELS = { unconfigured: "Не настроен", configured: "Настроен", ignored: "Игнорируется" };
export const MODE_LABELS = { observe: "Наблюдение", live: "Рабочий режим" };
export const ENABLED_LABELS = { true: "Включён", false: "Выключен" };
export const SENDER_POLICY_LABELS = { any: "Все отправители", allowlist: "Только разрешённые" };
export const ACTION_LABELS = { active: "Включение", inactive: "Остановка", info: "Информационное сообщение", replace_number: "Замена номера (архив)" };
export const TRIGGER_TYPE_LABELS = { word: "Слово", phrase: "Фраза", symbol: "Символ / emoji", regex: "Регулярное выражение" };

export const PROCESSING_STATUS_LABELS = {
  info: "Информационное событие", blocked_alias_start: "Включение запрещено для алиаса",
  manual_required: "Требуется ручное решение", processing: "Обрабатывается", skipped: "Пропущено", unresolved: "ЖК не определён",
  recognized: "Распознано", resolved: "ЖК определён", resolved_pending_application: "Ожидает применения",
  observe: "Наблюдение", applied: "Применено", failed: "Ошибка", unmatched: "ЖК не найден",
  ambiguous: "Неоднозначно", invalid: "Некорректное событие", ignored: "Игнорируется",
  missing_client: "Клиент отсутствует в ЖК", paused_global: "Остановлено глобально",
  paused_source_disabled: "Источник выключен",
};

export const APPLICATION_STATUS_LABELS = {
  success: "Успешно", failed_retryable: "Временная ошибка", rejected: "Отклонено",
  config_error: "Ошибка конфигурации", paused_global: "Остановлено глобально",
  paused_source_disabled: "Источник выключен", not_applied: "Не запускалось",
  applied: "Выполнено", already_current: "Состояние уже актуально", failed: "Ошибка",
};

export const RESOLUTION_STATUS_LABELS = {
  resolved: "ЖК определён", unmatched: "ЖК не найден", ambiguous: "Несколько вариантов",
  missing_client: "Клиент отсутствует в ЖК", invalid: "Некорректная привязка",
};

export const MATCH_METHOD_LABELS = {
  alias: "По алиасу", exact_normalized_name: "Точное совпадение",
  full_name_token_boundary: "По полному названию", manual_once: "Выбрано вручную",
  manual_alias: "Ручная привязка и алиас", manual_search: "Ручной поиск",
  exact_alias: "По алиасу из сообщения", exact_complex_name: "По точному названию ЖК",
  exact_name: "По названию ЖК",
  source_unique_alias_target: "Единственный ЖК, настроенный для этой группы",
  manual: "Выбрано вручную",
};

export const REASON_LABELS = {
  matched: "Правило найдено", no_match: "Подходящее правило не найдено",
  ambiguous_start_and_stop: "Одновременно найдены триггеры запуска и стопа",
  ambiguous_actions: "Одновременно найдены триггеры разных действий",
  sender_not_allowed: "Отправитель не входит в список разрешённых", admin_ignored: "Игнорировано администратором",
  "status action is not resolved": "Действие сообщения не определено",
  "source clientId is missing or invalid": "Клиент источника не указан или некорректен",
  "complex name is empty after trigger removal": "После удаления триггера не осталось названия ЖК",
  "alias target is missing": "ЖК, указанный в алиасе, больше не существует",
  "multiple complexes have the same normalized name": "Найдено несколько ЖК с одинаковым названием",
  "multiple full complex names occur on token boundaries": "Найдено несколько ЖК с совпадающим полным названием",
  "no safe automatic complex match": "Надёжное автоматическое совпадение ЖК не найдено",
  "invalid source clientId": "Клиент источника не указан или некорректен",
  "directory client is missing from complex.sipClients": "Клиент отсутствует в списке клиентов ЖК",
  "multiple embedded SIP rows have the source clientId": "В ЖК найдено несколько SIP-записей этого клиента",
  "alias embedded SIP row id is invalid": "В алиасе указан некорректный идентификатор SIP-строки",
  "alias embedded SIP row is missing": "SIP-строка из алиаса больше не существует",
  "alias embedded SIP row belongs to another client": "SIP-строка из алиаса принадлежит другому клиенту",
  "resolved by exact alias binding": "ЖК и SIP-строка определены по точной привязке алиаса",
  "embedded SIP row has invalid or missing _id": "SIP-запись ЖК имеет некорректный идентификатор",
  "resolved safely": "ЖК и клиент определены безопасно",
};

export const READINESS_LABELS = {
  configured: "Источник настроен", client: "Клиент существует", enabled: "Источник включён",
  start_trigger: "Есть триггер запуска", stop_trigger: "Есть триггер стопа",
  sender_policy: "Настройка отправителей корректна", sender_allowlist: "Список разрешённых отправителей не пуст",
  global_automation: "Глобальная автоматизация включена", backend_url: "Адрес backend настроен",
  backend_secret: "Секрет backend настроен", backend_timeout: "Тайм-аут backend корректен",
};

export const unknownLabel = (value) => value == null || value === "" ? "—" : `Неизвестно: ${String(value)}`;
export const enumLabel = (labels, value, empty = "—") => value == null || value === "" ? empty : labels[value] || unknownLabel(value);
export const sourceStatusLabel = (value) => enumLabel(SOURCE_STATUS_LABELS, value);
export const modeLabel = (value) => enumLabel(MODE_LABELS, value);
export const enabledLabel = (value) => value == null ? "—" : enumLabel(ENABLED_LABELS, String(value));
export const senderPolicyLabel = (value) => enumLabel(SENDER_POLICY_LABELS, value);
export const actionLabel = (value) => enumLabel(ACTION_LABELS, value);
export const triggerTypeLabel = (value) => enumLabel(TRIGGER_TYPE_LABELS, value);
export const processingStatusLabel = (value) => enumLabel(PROCESSING_STATUS_LABELS, value);
export const applicationStatusLabel = (value) => enumLabel(APPLICATION_STATUS_LABELS, value, "Не применялось");
export const eventApplicationState = (event) => {
  const response = event.applicationResult || {};
  const blocked = Boolean(event.guardCode);
  const succeeded = !blocked && ["success", "applied", "already_current"].includes(event.applicationStatus);
  const failed = ["failed", "failed_retryable", "rejected", "config_error"].includes(event.applicationStatus) || event.processingStatus === "failed";
  // New events record whether a backend request was sent; old snapshots only have counters/results.
  const attempted = typeof event.applicationAttempted === "boolean" ? event.applicationAttempted :
    Number(event.applicationAttempts) > 0 || succeeded || Boolean(event.applicationResult);
  const changed = typeof response.changed === "boolean" ? response.changed : event.serverChanged ?? event.backendChanged;
  return {
    attempted, succeeded: attempted && succeeded, failed,
    label: !attempted ? "Не запускалось" : blocked ? "Повторное применение остановлено" : succeeded ? "Выполнено" : failed ? "Ошибка" : "В процессе",
    changes: !blocked && succeeded && attempted && typeof changed === "boolean" ? changed ? "Да" : "Не потребовались — состояние уже актуально" : null,
  };
};
export const resolutionStatusLabel = (value) => enumLabel(RESOLUTION_STATUS_LABELS, value);
export const eventResolutionLabel = (event) => {
  if (event.resolutionStatus === "resolved") return "ЖК определён";
  if (event.resolutionCandidates?.length) return "Есть варианты — требуется ручное решение";
  if (event.searchPerformed === false && event.extractedComplexName === "") return "Название ЖК не указано; поиск не выполнялся";
  return resolutionStatusLabel(event.resolutionStatus);
};
export const matchMethodLabel = (value) => enumLabel(MATCH_METHOD_LABELS, value);
export const reasonLabel = (value) => value == null || value === "" ? "—" : REASON_LABELS[value] || String(value);
export const readinessLabel = (key) => READINESS_LABELS[key] || unknownLabel(key);

export const sourceMatches = (source, { query = "", mode = "", enabled = "", status = "" }) => {
  const needle = query.trim().toLocaleLowerCase();
  const haystack = [source.chatTitle, source.chatId, source.clientNameSnapshot].join(" ").toLocaleLowerCase();
  return (!needle || haystack.includes(needle)) && (!mode || source.mode === mode) &&
    (!enabled || String(source.enabled) === enabled) && (!status || source.status === status);
};

export const formatDate = (value) => value ? new Date(value).toLocaleString("ru-RU") : "—";
export const canEnableLive = (readiness) => readiness?.mongoConfigReady === true;

export const matchingEmbeddedSipClients = (complex, clientId) => (complex?.sipClients || []).filter(
  (row) => String(row?.clientId || "") === String(clientId || "")
);

export const embeddedSipClientLabel = (row) => {
  const number = row?.transfer_number ?? row?.sip_number;
  return `${row?.clientName || "Клиент"} · ${number == null || number === "" ? "—" : number}`;
};
